import { render, staticRenderFns } from "./ChangeDriverModal.vue?vue&type=template&id=20f0a696&scoped=true&"
import script from "./ChangeDriverModal.vue?vue&type=script&lang=js&"
export * from "./ChangeDriverModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDriverModal.vue?vue&type=style&index=0&id=20f0a696&prod&lang=scss&scoped=true&"
import style1 from "./ChangeDriverModal.vue?vue&type=style&index=1&id=20f0a696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0a696",
  null
  
)

export default component.exports